import { Role, RolePermissionScope, ToolRoom, User } from '@bechtel/ht-types';
import { FormikProps } from 'formik';
import { array, object, string } from 'yup';
export interface AvatarRegularStyledProps {
  hasImageUrl: boolean;
}
export interface UserDetailsProps {
  rolePermissionList: RolePermissionScope[];
}
export interface UserInfoDetailProps {
  userDetail?: User | null;
  mutationLoading: boolean;
  formikProps: FormikProps<initialValuesProps>;
  isProjectUser?: boolean;
  rolePermissionList: RolePermissionScope[];
}

export interface initialValuesProps {
  id: string;
  roles: Role[];
  isActive: boolean;
  persona: string;
  firstName: string;
  lastName: string;
  bun: string;
  upn: string;
  lobEmployeeId: string;
  supervisorId: string;
  supervisorBun: string;
  supervisorFirstName: string;
  supervisorLastName: string;
  supervisorLobEmployeeId: string;
  thUserId: string;
  toolHoundId: string;
  toolRooms: ToolRoom[];
  exemptedFromImport: boolean;
  thRole: string;
}

export const initialValues: initialValuesProps = {
  roles: [],
  isActive: true,
  persona: '',
  firstName: '',
  lastName: '',
  bun: '',
  supervisorId: '',
  supervisorBun: '',
  supervisorFirstName: '',
  supervisorLastName: '',
  supervisorLobEmployeeId: '',
  id: '',
  lobEmployeeId: '',
  upn: '',
  thUserId: '',
  toolHoundId: '',
  toolRooms: [],
  exemptedFromImport: false,
  thRole: '',
};

export const editUserValidationSchema = object().shape({
  roles: array().required().min(1, 'Select at least 1 Role'),
  firstName: string().required('First name is required'),
  lastName: string().required('Last name is required'),
  bun: string().required('BUN Id is required'),
  lobEmployeeId: string().required('etrack Id is required'),
  persona: string().required('Job Title is required'),
  upn: string().email().required('UPN is required'),
});
